__turbopack_context__.v({
  "input": "Time-module-scss-module__CE5nXq__input",
  "root": "Time-module-scss-module__CE5nXq__root",
});
